import React from 'react';

const ListText = ({ label, value, type, clickEvent, setClickedImage, linkUrl, badge, badgeColor, editableControl, editToggle, dataItem }) => {
    return (
        <>
            <li className={dataItem ? dataItem : "data-item"}>
                <div className="data-col">
                    <div className="data-label">{label}</div>
                    <div className={`data-value`}>
                        {value}
                    </div>
                </div>
            </li>
        </>
    );
};

export default ListText;